import { useQuery } from "@tanstack/react-query";
import { createFileRoute, useParams, useSearch } from "@tanstack/react-router";
import z from "zod";
import { jobQueryOptions } from "@/services/job/job.options";
import { OrgJobTypeFullIndexTabContent } from "./OrgJobTypeFullPage";

const FULL_INDEX =
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/jobTypes/$jobTypeId/full/" as const;

const FULL_PARENT =
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/jobTypes/$jobTypeId/full" as const;

export const Route = createFileRoute(FULL_INDEX)({
	component: OrgJobTypeFullIndexRoute,
	params: {
		parse: (raw) => {
			const p = raw as { orgId: string; jobTypeId: string };
			return {
				orgId: z.string().parse(p.orgId),
				jobTypeId: z.string().parse(p.jobTypeId),
			};
		},
	},
});

function OrgJobTypeFullIndexRoute() {
	const params = useParams({ from: FULL_PARENT });
	const search = useSearch({ from: FULL_PARENT });

	const detailQuery = useQuery(
		jobQueryOptions.jobTypeDetail(params.jobTypeId, {
			organizationId: params.orgId,
		}),
	);

	const jobType = detailQuery.data ?? null;

	if (!jobType) {
		return null;
	}

	return (
		<OrgJobTypeFullIndexTabContent
			tab={search.tab}
			jobType={jobType}
			orgId={params.orgId}
		/>
	);
}
